/* eslint-disable react-hooks/rules-of-hooks */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Card, Col, Input, Row, Select, Space, Typography } from "antd";
import { Icon, SvgIcon } from "assets/icons";
import CustomModal from "components/CustomModal";
import CustomTable from "components/CustomTable";
import FormInput from "components/FormInput";
import { INPUT_TYPE, PRODUCT_INPUT_TYPE } from "config/constants";
import {
  FilterLevelPrice,
  FilterManufacture,
} from "features/Campaign/components/Detail/ProductPromo/components/FilterProduct";
import RadioGroup from "features/Warranty/WarrantyList/component/RadioGroup";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { formatCurrency, validator } from "utils/helperFuncs";
import TagsList from "../TagsList";

import { Option } from "antd/lib/mentions";
import CustomTextHiddenLine from "components/CustomTextHiddenLine";
import { SEARCH_TYPE } from "pages/App/Product/constants";
import { FilterInstockVat, FilterVatPercent } from "pages/App/Product/Product/List/components/FilterProduct";
import { useEffect, useState } from "react";
import "./index.scss";
import useModalSelectGift from "./useModalSelectGift";

const FORM_ITEM_STYLE = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

function ModalSelectGift({
  useInModal,
  form,
  promotionCampaignTiers,
  isUpdate,
  dataProductsServer,
  isCheckboxType,
  isGift,
  isProduct,
  indexComboGift,
  indexPromotionCampaignTiers,
  indexConditionProductGroups,
}) {
  const {
    isModalSelectProduct,
    dataAllCategories,
    filterItemsTypeOptions,
    rowSelection,
    loadingProduct,
    isFilterSelected,
    selectedRows,
    productData,
    paginationData,
    prodAtt,
    warehouses,
    openModalSelectProduct,
    closeModalSelectProduct,
    handleSelectProduct,
    filterProductByCategoryId,
    handleSearchTreeSelect,
    handleSearch,
    handleChange,
    onTableChange,
    renderProductAttributes,
    renderChildrenInStock,
    params,
    dataManufactures,
    loadingManufactures,
    listWarehouse,
    loadingWarehouses,
    setParams,
    filterProductExtra,
    filterProductPrices,
    selectedProducts,
    isVisibleQuestionModal,
    handleCancelModalQuestion,
    handleSubmitQuestion,
    searchType,
    itemsSearchBulk,
    handleChangeSelectSearch,
    handleSelectSearchType,
  } = useModalSelectGift({
    form,
    promotionCampaignTiers,
    isUpdate,
    dataProductsServer,
    isCheckboxType,
    isGift,
    isProduct,
    indexComboGift,
    indexPromotionCampaignTiers,
    indexConditionProductGroups,
  });

  const columns = [
    //Mã sản phẩm
    {
      title: <Typography.Text>{t("product.tableTitle.code")}</Typography.Text>,
      dataIndex: "code",
      width: 150,
      fixed: "left",
      render: (_, record) => {
        return (
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <Link target={"_blank"} to={`/product/detail/${record?.id || record?.productID}`} className="linked-text">
              {record?.code}
            </Link>
            <CustomTextHiddenLine text={record?.name} line={1} />
          </div>
        );
      },
    },
    //Thương hiệu
    {
      title: <Typography.Text>{t("product.tableTitle.brand")}</Typography.Text>,
      dataIndex: ["manufacturer", "name"],
      align: "center",
      render: (_, record) => <div>{record?.manufacturer?.name ? record.manufacturer.name : "- -"}</div>,
      filterDropdown: <FilterManufacture dataManufactures={dataManufactures} onFilter={filterProductExtra} />,
    },
    //Bảo hành
    {
      title: <Typography.Text>{t("product.tableTitle.warranty")}</Typography.Text>,
      dataIndex: "warranty",
      align: "center",
      render: (_, record) => <div>{record?.warranty ? `${record.warranty} ${t("common.month")}` : "- -"}</div>,
    },
    ...renderProductAttributes(prodAtt),
    {
      title: "LOẠI % VAT",
      dataIndex: "vatPercent",
      align: "center",
      render: (_, record) => {
        return <div>{record.vatPercent >= 0 ? `${record.vatPercent}%` : "KCT"}</div>;
      },
      width: 150,
      editable: "true",
      inputType: PRODUCT_INPUT_TYPE.VAT_PERCENT,
      filterDropdown: <FilterVatPercent onFilter={filterProductExtra} defaultValue={params.filters.vatPercent} />,
    },
    {
      title: (
        <Typography.Text>
          <div className="title-table">GIÁ CÓ VAT</div>
        </Typography.Text>
      ),
      dataIndex: ["productPrices", "priceVat"],
      align: "right",
      render: (_, record) => {
        return (
          <div>
            {record?.productPrices?.priceVat ? formatCurrency(record?.productPrices?.priceVat) : formatCurrency(0)}
          </div>
        );
      },
      inputType: PRODUCT_INPUT_TYPE.CURRENCY,
      filterDropdown: (
        <FilterLevelPrice
          onFilter={(priceLevel) => {
            filterProductPrices(priceLevel, "priceVat");
          }}
          defaultValue={params.filters.priceVat}
        />
      ),
    },
    {
      title: <span>{t("product.tableTitle.inStockVat")}</span>,
      align: "center",
      render: (_, record) => {
        return (record?.stocks && record?.stocks[0].quantityRealStockHasVat) ?? 0;
      },
      width: 150,
      filterDropdown: (
        <FilterInstockVat onFilter={filterProductExtra} defaultValue={params?.filters?.realStockHasVat} />
      ),
    },
    //Tồn thực
    {
      title: <Typography.Text>{t("product.tableTitle.inStock")}</Typography.Text>,
      children: renderChildrenInStock(warehouses),
      align: "center",
    },
    //Tồn kho
    ...(useInModal
      ? [
          {
            title: (
              <Typography.Text>
                <div className="title-table">{t("product.tableTitle.inStock")}</div>
              </Typography.Text>
            ),
            align: "right",
            render: (_, record) => <div>{record?.stocks?.at(0).quantity || "- -"}</div>,
          },
        ]
      : []),
  ];

  const dataSelected = selectedProducts || [];

  const dataSource = isFilterSelected ? selectedRows : productData;

  const columnsListItemGift = [
    {
      title: (
        <Space direction="horizontal" style={{ alignItems: "center" }}>
          <Typography.Text>{t("campaign.combo.giftCode")}</Typography.Text>
          <div style={{ cursor: "pointer" }} onClick={() => openModalSelectProduct(true)}>
            <Badge count={dataSelected.length} showZero>
              <SvgIcon.EditSquare />
            </Badge>
          </div>
        </Space>
      ),
      align: "left",
      width: "50%",
      render: (_, record, index) => {
        return (
          <Space direction="vertical">
            <Link key={index} to={`/product/detail/${record?.id || record?.productID}`} target="_blank">
              <Typography.Link strong>{record?.code}</Typography.Link>
            </Link>
            <CustomTextHiddenLine text={record?.name} line={1} />
          </Space>
        );
      },
    },
    {
      title: <Typography.Text strong>{t("campaign.combo.giftBudget")}</Typography.Text>,
      align: "center",
      render: (_, record, index) => {
        const [quantity, setQuantity] = useState(null);
        const [minQuantity, setMinQuantity] = useState(0);

        useEffect(() => {
          const validRegionItems = record?.stocks?.filter((item) => item?.warehouse?.regionID !== null);
          const totalQuantity = validRegionItems?.reduce((acc, stock) => acc + (stock?.quantity || 0), 0);
          setMinQuantity(totalQuantity || 0);
          // Read from form values first, fallback to record
          const formValue = form.getFieldValue([
            indexPromotionCampaignTiers,
            "conditionGifts",
            indexConditionProductGroups,
            "conditionPromotionProducts",
            index,
            "budgetQuantity",
          ]);
          setQuantity(formValue || record.budgetQuantity || record.quantity);
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [record, index]);

        return (
          <FormInput
            type={INPUT_TYPE.NUMBER}
            {...{
              formItemOptions: {
                name: [indexConditionProductGroups, "conditionPromotionProducts", index, "budgetQuantity"],
                validateStatus: quantity > minQuantity ? "warning" : undefined,
                help: quantity > minQuantity ? t("cart.lackOfStock") : undefined,
                rules: [
                  { required: true, message: t("campaign.combo.errorMessage.qty") },
                  {
                    type: "number",
                    min: 1,
                    message: t("campaign.combo.errorMessage.valueMustBeThan0"),
                  },
                  validator({
                    type: "number",
                  }),
                ],
              },
              inputOptions: {
                placeholder: t("campaign.combo.placeholder.type"),
                className: "input-number",
                maxLength: 10,
                onChange: (value) => setQuantity(value),
              },
            }}
          />
        );
      },
    },
    {
      title: <Typography.Text strong>{t("campaign.combo.warrantyDate")}</Typography.Text>,
      align: "center",
      render: (_, record, index) => {
        const [warranty, setWarranty] = useState(null);

        useEffect(() => {
          // Read from form values first, fallback to record
          const formValue = form.getFieldValue([
            indexPromotionCampaignTiers,
            "conditionGifts",
            indexConditionProductGroups,
            "conditionPromotionProducts",
            index,
            "productWarranty",
          ]);
          setWarranty(formValue || record.productWarranty || record.warranty);
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [record, index]);

        return (
          <FormInput
            type={INPUT_TYPE.NUMBER}
            {...{
              formItemOptions: {
                name: [indexConditionProductGroups, "conditionPromotionProducts", index, "productWarranty"],
                validateStatus: warranty > record?.warranty ? "warning" : undefined,
                help: warranty > record?.warranty ? t("campaign.combo.warrantyDateWarning") : undefined,
                rules: [
                  {
                    required: (warranty === null || record?.warranty === null) && true,
                    message: t("campaign.combo.errorMessage.qty"),
                  },
                  validator({
                    type: "number",
                  }),
                ],
              },
              inputOptions: {
                placeholder: record?.warranty || t("campaign.combo.placeholder.type"),
                className: "input-number",
                maxLength: 10,
                // defaultValue: record?.warranty,
                onChange: (value) => setWarranty(value),
              },
            }}
          />
        );
      },
    },
  ];

  const renderCustomComponent = () => {
    if (dataSelected?.length) {
      return (
        <CustomTable
          columns={columnsListItemGift}
          dataSource={dataSelected}
          scroll={{
            y: 240,
          }}
        />
      );
    }
    return (
      <Typography.Link onClick={() => openModalSelectProduct(true)} underline>
        {t("campaign.combo.selectProductCodeGift")}
      </Typography.Link>
    );
  };

  return (
    <div className="custom-modal-select-product">
      <CustomModal
        footer={false}
        centered={true}
        visible={isVisibleQuestionModal}
        title={<Typography.Text style={{ fontSize: "22px" }}>{t("campaign.combo.changeCategory")}</Typography.Text>}
        message={
          <div style={{ textAlign: "justify", marginTop: "-20px" }}>{t("campaign.combo.questionModalCategory")}</div>
        }
        onCancel={handleCancelModalQuestion}
        onOke={() => handleSubmitQuestion()}
      />
      <Card className="custom-card-select-product">
        <CustomModal
          {...{
            message: <Typography.Title level={3}>{t("campaign.combo.addProductToPromotion")}</Typography.Title>,
            footer: false,
            width: "fit-content",
            visible: isModalSelectProduct,
            onOpen: openModalSelectProduct,
            onCancel: closeModalSelectProduct,
            onOke: handleSelectProduct,
            okeButtonLabel: t("campaign.combo.addProduct"),
            children: (
              <>
                <Row
                  gutter={[16, 4]}
                  style={{
                    alignItems: "center",
                    borderRadius: "8px",
                    margin: 0,
                  }}
                >
                  <Col span={6}>
                    <FormInput
                      type={INPUT_TYPE.TREE_SELECT}
                      formItemOptions={{
                        ...FORM_ITEM_STYLE,
                        placeholder: t("product.productForm.placeholderCategory"),
                        label: <Typography.Text strong>{t("product.productForm.category")}</Typography.Text>,
                        // name: 'categoryIDs',
                        style: { marginBottom: 0 },
                      }}
                      inputOptions={{
                        placeholder: t("product.productForm.placeholderCategory"),
                        treeData: dataAllCategories,
                        showSearch: true,
                        allowClear: true,
                        onChange: filterProductByCategoryId,
                        filterTreeNode: (search, item) => handleSearchTreeSelect(search, item),
                      }}
                    />
                  </Col>
                  <Col span={10}>
                    <div style={{ height: "32px", display: "flex", alignItems: "center" }}>
                      <Typography.Text strong>{t("campaign.combo.searchAdvance")}</Typography.Text>
                    </div>
                    <div className="custom-search-product-wrapper">
                      <Input.Group compact>
                        <Select
                          onChange={handleSelectSearchType}
                          defaultValue={searchType}
                          value={searchType}
                          className="select-search-type"
                        >
                          <Option value={SEARCH_TYPE.SINGLE}>Tìm kiếm từng mã sản phẩm</Option>
                          <Option value={SEARCH_TYPE.BULK}>Tìm kiếm hàng loạt</Option>
                        </Select>
                        {searchType === SEARCH_TYPE.SINGLE ? (
                          <Input
                            prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
                            placeholder={t("product.searchPlaceholder")}
                            onChange={handleSearch}
                            allowClear={true}
                            defaultValue={params.filters.query}
                            style={{ width: "350px" }}
                          />
                        ) : (
                          <Select
                            mode="tags"
                            value={itemsSearchBulk}
                            onChange={handleChangeSelectSearch}
                            placeholder="Tìm kiếm các mã sản phẩm được ngăn cách với nhau bằng dấu phẩy/ đấu cách"
                            className="custom-select-search-product"
                            open={false}
                            dropdownStyle={{ display: "none" }}
                          />
                        )}
                      </Input.Group>
                    </div>
                  </Col>
                  <Col span={8} style={{ paddingTop: "30px" }}>
                    <RadioGroup
                      filterItemsTypeOptions={filterItemsTypeOptions}
                      handleChange={handleChange}
                      isUpdate={isUpdate}
                    />
                  </Col>
                  <Col span={24}>
                    <Typography.Text style={{ color: "orange" }}>{t("campaign.combo.notingModal")}</Typography.Text>
                  </Col>
                  <Col span={24}>
                    <TagsList
                      listFilter={params.filters}
                      dataManufactures={dataManufactures}
                      loadingManufactures={loadingManufactures}
                      dataWarehouses={listWarehouse}
                      loadingWarehouses={loadingWarehouses}
                      dataAttributes={prodAtt}
                      params={params}
                      setParams={setParams}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <CustomTable
                      rowSelection={{
                        type: "checkbox",
                        ...rowSelection,
                      }}
                      columns={columns}
                      loading={loadingProduct}
                      dataSource={dataSource}
                      rowKey={(record) => record?.id}
                      onChange={onTableChange}
                      pagination={{
                        total: isFilterSelected ? selectedRows?.length : paginationData?.total,
                        pageSize: paginationData?.limit,
                        current: paginationData?.offset / paginationData?.limit + 1 || 1,
                        showSizeChanger: false,
                      }}
                    />
                  </Col>
                </Row>
              </>
            ),
          }}
        />
        {renderCustomComponent()}
      </Card>
    </div>
  );
}

export default ModalSelectGift;
